import { render, staticRenderFns } from "./AuthorList.vue?vue&type=template&id=c41b917c&scoped=true&"
import script from "./AuthorList.vue?vue&type=script&lang=js&"
export * from "./AuthorList.vue?vue&type=script&lang=js&"
import style0 from "./AuthorList.vue?vue&type=style&index=0&id=c41b917c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c41b917c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VLayout})
